import React, { Component } from 'react';
import {c_light, c_background, c_gradient_reds} from '../a-Graphic/Colors';
import Info from '../f-Utilities/Info';

import getMyMap, {managePopup, createCommuneBordersLayer, createAreasMassLayer, createNamesLayer, createCommuneLayerFlows, createCommuneFlowsLayer, getLegendMode, calcDist} from '../b-LeafletMap/leaflet_map';

import LegendCommune from '../b-LeafletMap/Legend/LegendCommune';
import LegendClusterArea from '../b-LeafletMap/Legend/LegendClusterArea';
import LegendValuesFlows from '../b-LeafletMap/Legend/LegendValuesFlows';

const L = window.L;

var f_limit_all = 20;

class WorkFlowsAll extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      legend: {
        intervals : [],
        colors: []
      },
      limit_flows_nb: 100
    };

    this.mode = "ckmeans";
    this.colors = c_gradient_reds;

    /* COMMUNES */
    var communes = this.props.territory.communes;
    var influence_communes = this.props.territory.influence_communes;
    var work_communes = this.props.territory.work_communes;

    var communes_coords = communes.map((c) => c.center);
    var communes_names = communes.map((c) => c.name);

    var communes_geo_codes_to_coords = {};
    communes.concat(influence_communes).concat(work_communes).map((c) => communes_geo_codes_to_coords[c.geo_code] = c.center)
    var communes_geo_codes_to_names = {};
    communes.concat(influence_communes).concat(work_communes).map((c) => communes_geo_codes_to_names[c.geo_code] = c.name)

    let flows = []
    communes.forEach((c, i) => {
      Object.keys(c.flows_home_work).filter((c_geo)=> c.flows_home_work[c_geo]>f_limit_all).forEach((c_geo) => {
        flows.push({
          coords: [c.center, communes_geo_codes_to_coords[c_geo]],
          mass: c.flows_home_work[c_geo],
          label: c.name + " → " + communes_geo_codes_to_names[c_geo]  + " : " + c.flows_home_work[c_geo].toLocaleString("fr-FR") + " navetteurs"
        })
      })

      let within_flow = parseInt(c.workers_within_commune_prop * c.status.employed)
      if (within_flow >= 30){
        flows.push({
          coords: [c.center, c.center],
          mass: within_flow,
          label: c.name + " → " + c.name  + " : " + within_flow.toLocaleString("fr-FR") + " navetteurs"
        })
      }
    });

    this.flows = flows.sort(((a,b)=> b.mass - a.mass))

    // compute prop external/internal work distance
    let internal_flows_distance = communes.map((c) => Object.keys(c.flows_home_work)
                                            .filter((c_geo)=> communes.map((co)=>co.geo_code).includes(c_geo) && c.flows_home_work[c_geo]>f_limit_all)
                                            .map((c_geo) => c.flows_home_work[c_geo] * calcDist(c.center, communes_geo_codes_to_coords[c_geo]))
                                            .reduce((a, b) => a + b, 0)).reduce((a, b) => a + b, 0)
    let total_flows_distance = communes.map((c) => Object.keys(c.flows_home_work)
                                            .filter((c_geo)=> c.flows_home_work[c_geo]>f_limit_all)
                                            .map((c_geo) => c.flows_home_work[c_geo] * calcDist(c.center, communes_geo_codes_to_coords[c_geo]))
                                            .reduce((a, b) => a + b, 0)).reduce((a, b) => a + b, 0)
    this.prop_external_work_distance = Math.round(100 - internal_flows_distance/total_flows_distance*100)
  }

  setNbFlows = (value) => {
      this.setState({
        limit_flows_nb: parseInt(value)
      })
  }

  get_flows(limit_flows_nb) {
    let flows = this.flows
    flows = flows.slice(0, limit_flows_nb)

    let flows_coords = flows.map((f) => f.coords)
    let flows_masses = flows.map((f) => f.mass)
    let flows_labels = flows.map((f) => f.label)

    return {flows_coords, flows_masses, flows_labels}
  }


  componentDidMount() {
    /* COMMUNES */
    let communes = this.props.territory.communes;

    let {flows_coords, flows_masses, flows_labels} = this.get_flows(this.state.limit_flows_nb)

    // --- init map
    let mymap = this.mymap = getMyMap(this.props.id, true, 0.3);

    let communes_layer = this.communes_layer = createCommuneBordersLayer(mymap, communes)
    this.flows_layer = createCommuneFlowsLayer(mymap, flows_coords, flows_masses, flows_labels, this.mode, this.colors);

    // --- legend
    let [legend_intervals, legend_colors] = getLegendMode(this.mode, flows_masses, this.colors)
    this.setState({
      legend: {intervals: legend_intervals, colors: legend_colors}
    })

    // --- center the map
    mymap.fitBounds(communes_layer.getBounds());
  }

  componentDidUpdate(prevProps, prevState){
    if (this.state.limit_flows_nb != prevState.limit_flows_nb){
      let {flows_coords, flows_masses, flows_labels} = this.get_flows(this.state.limit_flows_nb)
      this.mymap.removeLayer(this.flows_layer)
      this.flows_layer = createCommuneFlowsLayer(this.mymap, flows_coords, flows_masses, flows_labels, this.mode, this.colors);


      let [legend_intervals, legend_colors] = getLegendMode(this.mode, flows_masses, this.colors)
      this.setState({
        legend: {intervals: legend_intervals, colors: legend_colors},
        flow_masses: flows_masses,
      })
    }
  }

  render() {
    return(
          <div className="row align-items-end">
            <div className="col-10">
              <div style={{height: "500px"}} id={this.props.id}></div>
            </div>
            <div className="col-2 pl-0 pr-0">
                 <p className="mb-3">Vue d'ensemble des navetteurs habitant le territoire.
                 <Info content={this.prop_external_work_distance + "% des distances domicile-travail parcourues sont vers des communes extérieures au territoire d'étude"} /></p>
                 <form>
                   <div class="form-group mb-1">
                     <input onChange={(e) => this.setNbFlows(e.target.value)}
                     type="range" class="custom-range" min="25" max="200" step="25" id={"range_"+this.props.id} value={this.state.limit_flows_nb} />
                   </div>
                 </form>
                  <p className="mb-3">Seuls les {this.state.limit_flows_nb} flux les plus importants sont affichés. (De plus de {f_limit_all} navetteurs.)</p>
                 <LegendValuesFlows intervals={this.state.legend.intervals} colors={this.state.legend.colors}/>
            </div>
          </div>
    )
  }
}

export default WorkFlowsAll;
